import { SaveButton } from "components/Buttons"
import { TagsMultiSelect, TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { Col, Row } from "reactstrap"
import { Field, formValueSelector, reduxForm } from "redux-form"
import validate from "./domainFormValidation"
import { withRouter } from "react-router-dom"

let DomainForm = props => {
  const { handleSubmit, loading, metaTags, onTagCreate, initialValues } = props

  return (
    <form onSubmit={handleSubmit}>
      <Row className="d-flex justify-content-end">
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Back"
            onClick={() => {
              props?.history.goBack()
            }}
            color="light"
          />
        </Col>
      </Row>

      <Row className="form-group mt-3">
        <Col>
          <Field name={"name"} label={"Domain"} component={TextField} />
        </Col>
      </Row>

      <Row className="form-group mt-3">
        <Col>
          <Field
            name={"tags"}
            label={"Tags"}
            component={TagsMultiSelect}
            create={onTagCreate}
            options={metaTags.map(({ id, tag }) => ({ value: id, label: tag }))}
          />
        </Col>
      </Row>

      <Row className="form-group mt-3">
        <Col>
          <SaveButton
            content={initialValues && initialValues.id ? "Update" : "Add"}
            loading={loading}
          />
        </Col>
      </Row>
    </form>
  )
}

DomainForm = reduxForm({
  form: FORM_NAMES.DOMAIN, // must be unique
  validate,
})(DomainForm)

export default withRouter(DomainForm)
